<div [class]="classPrefix('MainPod')">
  <penrose></penrose>
  <span [class]="classPrefix('MainText0')">{{ baseService.updateOverlayLoadingText | translate}}</span>
</div>
